export enum LoadingStatus {
    NotLoaded = 'NotLoaded',
    FailedToLoad = 'FailedToLoad',
    Loading = 'Loading',
    Loaded = 'Loaded',
}
